/**
 * @generated SignedSource<<bc4ad19b5a187955a15783d03396201f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoFileStatus = "ERROR" | "PROCESSING" | "READY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type courseVideo_video$data = {
  readonly id: string;
  readonly muxId: string | null | undefined;
  readonly playback: {
    readonly playback: string;
    readonly tokens: {
      readonly playback: string | null | undefined;
      readonly storyboard: string | null | undefined;
      readonly thumbnail: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly rawID: string;
  readonly status: VideoFileStatus;
  readonly url: string;
  readonly " $fragmentType": "courseVideo_video";
};
export type courseVideo_video$key = {
  readonly " $data"?: courseVideo_video$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseVideo_video">;
};

import CourseVideoVideoQuery_graphql from './CourseVideoVideoQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CourseVideoVideoQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "courseVideo_video",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "muxId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoPlayback",
      "kind": "LinkedField",
      "name": "playback",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoFileTokens",
          "kind": "LinkedField",
          "name": "tokens",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "storyboard",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnail",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VideoFile",
  "abstractKey": null
};
})();

(node as any).hash = "2905029f79b0afcd7f07ac6e93452459";

export default node;
